module.exports = __webpack_public_path__ + "img/level2.4a2c6580.png";